const c = {
  name: "TechTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,3h1H18c0,0.5,0.1,0.9,0.3,1.3L15.6,7H13V5.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3S9,1.3,9,3
			c0,1.3,0.8,2.4,2,2.8V7H8.4L5.7,4.3C5.9,3.9,6,3.5,6,3c0-1.7-1.3-3-3-3S0,1.3,0,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3L7.6,9h8.8
			l3.3-3.3C20.1,5.9,20.5,6,21,6h0c0.6,0,1.2-0.2,1.7-0.5c0.5-0.3,0.9-0.8,1.1-1.3C24,3.6,24.1,3,23.9,2.4c-0.1-0.6-0.4-1.1-0.8-1.5
			c-0.4-0.4-1-0.7-1.5-0.8C21-0.1,20.4,0,19.9,0.2c-0.5,0.2-1,0.6-1.3,1.1C18.2,1.8,18,2.4,18,3z M20.6,2.1C20.8,2,21,2,21.2,2
			c0.2,0,0.4,0.1,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.4,0.4C21.4,3.9,21.2,4,21,4
			c-0.3,0-0.5-0.1-0.7-0.3l0,0C20.1,3.5,20,3.3,20,3c0-0.2,0.1-0.4,0.2-0.6C20.3,2.3,20.4,2.2,20.6,2.1z M13,3c0,0.6-0.4,1-1,1
			s-1-0.4-1-1s0.4-1,1-1S13,2.4,13,3z M4,3c0,0.2-0.1,0.5-0.2,0.6L3.6,3.8C3.5,3.9,3.2,4,3,4C2.4,4,2,3.6,2,3s0.4-1,1-1S4,2.4,4,3z"
			/>
		<path class="st0" d="M11,18.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V17h2.6l2.7,2.7
			C18.1,20.1,18,20.5,18,21c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3c-0.5,0-0.9,0.1-1.3,0.3L16.4,15H7.6l-3.3,3.3
			C3.9,18.1,3.5,18,3,18h0c-0.6,0-1.2,0.2-1.7,0.5c-0.5,0.3-0.9,0.8-1.1,1.3C0,20.4-0.1,21,0.1,21.6c0.1,0.6,0.4,1.1,0.8,1.5
			c0.4,0.4,1,0.7,1.5,0.8C3,24.1,3.6,24,4.1,23.8c0.5-0.2,1-0.6,1.3-1.1C5.8,22.2,6,21.6,6,21l0,0c0-0.4-0.1-0.9-0.3-1.3L8.4,17H11
			V18.2z M12,20c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S11.4,20,12,20z M20.2,20.4l0.2-0.2c0.2-0.1,0.4-0.2,0.6-0.2c0.6,0,1,0.4,1,1
			s-0.4,1-1,1s-1-0.4-1-1C20,20.8,20.1,20.5,20.2,20.4z M3,20c0.3,0,0.5,0.1,0.7,0.3l0,0C3.9,20.5,4,20.7,4,21
			c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.3-0.4,0.4C3.2,22,3,22,2.8,22c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5
			c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.4-0.4C2.6,20.1,2.8,20,3,20z"/>
		<path class="st0" d="M5.8,11C5.4,9.8,4.3,9,3,9c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h12.3c0.4,1.2,1.5,2,2.8,2
			c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5.8z M2,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S2,12.6,2,12z M20,12
			c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S20,12.6,20,12z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as TechTeam
};
